/* eslint-disable no-use-before-define */
import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { Box, Button, IconButton } from '@mui/material';
import { AddCircleOutlined } from '@mui/icons-material';

const filter = createFilterOptions();

const SelectAddCombo = props => {
  const { label, name, value, options, variant, error, helperText, fullWidth, onBlur, onChange } = props;

  return (
    <Autocomplete
      name={name}
      value={value}      
      onBlur={onBlur}
      onChange={onChange}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);
        // Suggest the creation of a new value
        if (params.inputValue !== '') {
          filtered.push({
            inputValue: params.inputValue,
            name: <Button color='primary' variant='text' startIcon={<AddCircleOutlined />}>{`Add ${params.inputValue}`}</Button>,
          });
        }

        return filtered;
      }}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      id='select-add-combo'
      options={options}
      getOptionLabel={(option) => {
        // Value selected with enter, right from the input
        if (typeof option === 'string') {
          return option;
        }
        // Add "xxx" option created dynamically
        if (option.inputValue) {
          return option.inputValue;
        }
        // Regular option
        return option.name;
      }}
      renderOption={(props, option) => {
        const { key, ...optionProps } = props;
        return (
          <li key={key} {...optionProps}>
            {option.name}
          </li>
        );
      }}
      fullWidth={fullWidth}
      freeSolo
      renderInput={(params) => (
        <TextField 
          name={name} 
          value={value} {...params} 
          label={label} 
          variant={variant} 
          error={error}
          helperText={helperText}
          size='small'
        />
      )}
    />
  );
}

export default SelectAddCombo;